import React, { useState } from 'react';
import {
  Box,
  Typography,
  Grid,
  Paper,
  Divider
} from '@mui/material';
import { useFormularioSecretariaMunicipalAgriculturaStore } from 'stores/forms/formularioAgricultura.store';
import { KeyboardArrowDownOutlined, KeyboardArrowUpOutlined } from '@mui/icons-material';

const InfoField: React.FC<{ label: string; value: any }> = ({
  label,
  value,
}) => (
  <Box>
    <Typography
      sx={{
        fontWeight: 400,
        fontSize: "14px",
        lineHeight: "143%",
        letterSpacing: "0.17px",
        color: "text.secondary",
        mb: 0.5,
      }}
      gutterBottom
    >
      {label}
    </Typography>
    <Typography
      sx={{
        fontWeight: 400,
        fontSize: "16px",
        lineHeight: "24px",
        letterSpacing: "0.15px",
        color: "text.primary",
      }}
    >
      {value || 'Não informado'}
    </Typography>
  </Box>
);

const Step1View: React.FC = () => {
  const { formulario } = useFormularioSecretariaMunicipalAgriculturaStore();
  const [open, setOpen] = useState<boolean>(true);

  if (!formulario) {
    return (
      <Box justifyContent="center" display="flex" p={3}>
        <Typography>Carregando informações...</Typography>
      </Box>
    );
  }

  return (
    <Paper elevation={1} sx={{ p: 0, mt: 2 }}>
      <Box
        sx={{ px: 3, pt: 2, cursor: 'pointer', userSelect: 'none' }}
        onClick={() => setOpen(!open)}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: 500,
              color: "#000000DE",
              fontSize: "20px",
              mb: 1,
              display: "flex",
              alignItems: "center",
              gap: 0.5,
            }}
          >
            {open ? (
              <KeyboardArrowUpOutlined
                sx={{ color: "text.secondary", fontSize: 20 }}
              />
            ) : (
              <KeyboardArrowDownOutlined
                sx={{ color: "text.secondary", fontSize: 20 }}
              />
            )}
            Informações Gerais
          </Typography>
        </Box>
        <Divider sx={{ mb: 1 }} />
      </Box>

      {open && (
        <Box sx={{ p: 3 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <InfoField
                label="Tipo da Unidade Administrativa"
                value={formulario.tipo_unidade_administrativa}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <InfoField
                label="Nome da Unidade Administrativa"
                value={formulario.nome_secretaria}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <InfoField
                label="Ano de Referência"
                value={new Date().getFullYear() - 1}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <InfoField
                label="Endereço"
                value={formulario.endereco}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <InfoField
                label="Número"
                value={formulario.endereco_numero}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <InfoField
                label="Bairro"
                value={formulario.bairro}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <InfoField
                label="CEP"
                value={formulario.cep}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <InfoField
                label="Email da Secretaria"
                value={formulario.email}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <InfoField
                label="Telefone"
                value={formulario.telefone}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <InfoField
                label="Telefone 2"
                value={formulario.telefone2}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <InfoField
                label="Nome do(a) Responsável pela Unidade Administrativa"
                value={formulario.nome_responsavel}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <InfoField
                label="Email do(a) Responsável pela Unidade Administrativa"
                value={formulario.email_responsavel}
              />
            </Grid>
          </Grid>
        </Box>
      )}
    </Paper>
  );
};

export default Step1View;
